import React from "react";
import { useMediaQuery } from "react-responsive";
import { useGlobalContext } from "../../utils/globalContext";
import SectionHeading from "./sectionHeading";
import SolutionsList from "./solutionsList";
import { LazyLoadImage } from "react-lazy-load-image-component";

export default function VaccinationSection({ content }) {
  const { Trans } = useGlobalContext();
  const isMobile = useMediaQuery({ query: "(max-width: 576px)" });

  return (
    <div className={`vaccinationSection ${isMobile ? "mobile" : ""}`}>
      <div className="left">
        <div className="solutionsSection">
          <SectionHeading title={content.title} />
          <p className="description">
            <Trans>{isMobile ? content.descriptionMobile : content.description}</Trans>
          </p>
          <h3 className="solutionsTitle">{content.listTitle}</h3>
          <SolutionsList list={content.list} />
          <p className="solutionsDescription">
            <Trans>{isMobile ? content.bottomLineMobile : content.bottomLine}</Trans>
          </p>
          <a href={content.buttonLink} className="linkPrimary sm">
            <span>{content.buttonText}</span>
          </a>
        </div>
      </div>
      {!isMobile && (
        <div className="right">
          <LazyLoadImage src={content.image?.url} alt="vaccine" effect="blur" />
        </div>
      )}
    </div>
  );
}
